import { render, staticRenderFns } from "./sceneList.vue?vue&type=template&id=65036ddf&scoped=true"
import script from "./sceneList.vue?vue&type=script&lang=js"
export * from "./sceneList.vue?vue&type=script&lang=js"
import style0 from "./sceneList.vue?vue&type=style&index=0&id=65036ddf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65036ddf",
  null
  
)

export default component.exports